import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2, 11),
  },
  listItem: {
    opacity: 0.6,
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.main,
    marginBottom: theme.spacing(2),
    height: theme.spacing(11),
    display: "flex",
    alignItems: "center",
  },
  block: {
    borderRight: `1px solid ${theme.palette.background.main}`,
    height: "90%",
  },
  listItemContainer: {
    minHeight: theme.spacing(100),
  },
}));
